import axios from 'axios'
import router from '../router'
import { Message } from 'element-ui'
import store from '@/store'
import error from './error'
let url = ''
if (process.env.NODE_ENV === 'development') {
    url = ''
} else if (process.env.NODE_ENV === 'production') {
    url = ''
}

const request = axios.create({
    baseURL: url
})

function refreshToken () {
    var FormData = require('form-data')
    var data = new FormData()
    data.append('grant_type', 'refresh_token')
    data.append('refresh_token', localStorage.getItem('refresh_token'))
    data.append('client_id', 'client-app')
    data.append('client_secret', '123456')
    data.append('type', 'ADMIN')
    return request({
        url: '/api/crm/oauth/token',
        method: 'post',
        data: data
    })
}
var list = []
let refreshTokening = false
let longTime = false

let white = [
    '/api/crm/oauth/token',
    '/api/crm/socialLogin/weixin',
    '/api/crm/authentication/mobile',
    '/api/crm/open/user/findPwd',
    '/api/crm/code/sms',
    '/api/crm/open/user/wxRegister'
]
request.interceptors.request.use(config => {
    config.headers.token = window.localStorage.getItem('access_token')

    if (
        !(white.some(item => {
            return config.url === item || config.url.indexOf(item)
        })) &&
        localStorage.getItem('accessTokenExpiry') - new Date().getTime() <= 1000 * 30 * 60) {
        if (!longTime && localStorage.getItem('refreshTokenExpiry') - new Date().getTime() < 1000 * 60) {
            longTime = true
            Message.error('长时间未登录，请重新登录')
            localStorage.removeItem('userId')
            localStorage.removeItem('token')
            localStorage.removeItem('accessTokenExpiry')
            localStorage.removeItem('refresh_token')
            localStorage.removeItem('refreshTokenExpiry')
            localStorage.removeItem('key')
            localStorage.removeItem('access_token')
            store.commit('user/changeIsLogin', false)
            router.push('/login')
            setTimeout(_ => {
                longTime = false
            }, 1000)
            return false
        }

        if (!refreshTokening) {
            refreshTokening = true
            refreshToken().then(res => {
                window.localStorage.setItem('token', res.data.access_token)
                window.localStorage.setItem('access_token', res.data.access_token)
                window.localStorage.setItem('accessTokenExpiry', res.data.accessTokenExpiry)
                window.localStorage.setItem('refresh_token', res.data.refresh_token)
                window.localStorage.setItem('refreshTokenExpiry', res.data.refreshTokenExpiry)
                refreshTokening = false
                return res.data.access_token
            }).then((token) => {
                list.forEach(cb => cb(token))
                list = []
            })
        }

        let retryOriginalRequest = new Promise((resolve, reject) => {
            list.push((token) => {
                config.headers.token = token
                resolve(config)
            })
        })

        return retryOriginalRequest
    } else {
        return config
    }
})

var authLock = false

request.interceptors.response.use(res => {
    if (res.data.success) {
        return res
    }
    if (res.data.constructor === Blob) {
        return res
    }
    if (res.data.message === 'auth.unauthorized' || res.data.message === 'geteway.unauthorized') {
        if (!authLock) {
            authLock = true
            Message.error('暂未登录或登录凭证已经过期，请重新登录！')
            router.push('/login')
        }
        setTimeout(_ => {
            authLock = false
        }, 1000)
        return res
    }

    let text = error[res.data.message] || res.data.error
    Message.error(text)
    return res
}, err => {
    let message = err.response.data.message
    console.log(error[message], '错误信息')
    let note = error[message] ? error[message] : '数据错误，请联系管理员'
    // Notification({ title: '警告', message: note, type: 'error' })
    Message.error(note)
})
const defulteHeaders = {
    'Content-Type': 'application/x-www-form-urlencoded'
}
export const sync = (url, method) => request({ url, method: method || 'get', headers: defulteHeaders })
export default request
